/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_UnsupportedInputs */

const en_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser cannot receive notifications on this device.`)
};

/**
* | output |
* | --- |
* | "This browser cannot receive notifications on this device." |
*
* @param {Push_UnsupportedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_unsupported = /** @type {((inputs?: Push_UnsupportedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_UnsupportedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_unsupported(inputs)
});